import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import gql from 'graphql-tag';
import useSearchablePages from '../hooks/useSearchablePages';
import FormFieldPageSelect from '../components/FormFieldPageSelect';

const GET_PAGES = gql`
  query GetApplyPageLayoutPages(
    $excludeIds: [ID!],
    $excludeTypes: [String!],
    $first: Int!,
    $fulltext: String,
    $locale: String!,
    $includeVersions: Boolean,
  ) {
    pages(filter: {
      excludeIds: $excludeIds,
      excludeTypes: $excludeTypes,
      fulltext: $fulltext,
      locale: $locale,
      }, first: $first, includeVersions: $includeVersions) {
      ...ApplyPageLayoutPagesConnection
    }
  }
  ${FormFieldPageSelect.fragments.pagesConnection.applyLayout}
`;

const propTypes = {
  currentPageId: PropTypes.string,
  excludeTypes: PropTypes.arrayOf(PropTypes.string),
  includeDate: PropTypes.bool,
};

const defaultProps = {
  currentPageId: undefined,
  excludeTypes: undefined,
  includeDate: undefined,
};

const Container = ({ currentPageId, excludeTypes, ...rest }) => {
  const { locale } = useIntl();
  const [state, { onChange }] = useSearchablePages(
    GET_PAGES,
    ({ fulltext }) => ({
      variables: {
        excludeIds: [currentPageId],
        excludeTypes,
        first: 10,
        fulltext,
        locale,
        includeVersions: true,
      },
    }),
  );

  return (
    <FormFieldPageSelect
      {...rest}
      {...state}
      onSearch={onChange}
      resetValue=""
      searchable
    />
  );
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

export default Container;
